export interface ProjectOption<T = string | number> {
  value: T
  label: string
  emoji: string
  description: string
}

export const IMPORTANCE_OPTIONS: ProjectOption<number>[] = [
  { value: 0, label: 'None', emoji: '🤷', description: 'Not important at all' },
  { value: 1, label: 'Low', emoji: '💡', description: 'Nice to have' },
  { value: 2, label: 'Medium', emoji: '📌', description: 'Should be done' },
  { value: 3, label: 'High', emoji: '🔥', description: 'Must be done' }
]

export const URGENCY_OPTIONS: ProjectOption<number>[] = [
  { value: 1, label: 'Low', emoji: '🐌', description: 'Can wait weeks/months' },
  { value: 2, label: 'Medium', emoji: '🚶', description: 'Should be done soon' },
  { value: 3, label: 'High', emoji: '🏃', description: 'Needs immediate attention' }
]

export const SCOPE_OPTIONS: ProjectOption<number>[] = [
  { value: 1, label: 'Short', emoji: '⚡', description: '< 2 hours' },
  { value: 2, label: 'Medium', emoji: '⏰', description: '2-8 hours' },
  { value: 3, label: 'Long', emoji: '🏔️', description: '> 8 hours' }
]

export const ENJOYMENT_OPTIONS: ProjectOption<number>[] = [
  { value: 5, label: 'Very High', emoji: '🤩', description: 'Absolutely love doing this!' },
  { value: 4, label: 'High', emoji: '😄', description: 'Very enjoyable' },
  { value: 3, label: 'Medium', emoji: '😊', description: 'Enjoyable' },
  { value: 2, label: 'Low', emoji: '🙂', description: 'Somewhat enjoyable' },
  { value: 1, label: 'N/A', emoji: '🤷', description: 'Neutral/indifferent' },
  { value: 0, label: 'Negative', emoji: '😐', description: 'Not enjoyable' },
  { value: -1, label: 'Very Negative', emoji: '😫', description: 'Really don\'t want to do this' }
]

export const STATUS_OPTIONS: ProjectOption<string>[] = [
  { value: 'Current', label: 'Current', emoji: '🎯', description: 'Ready to work on now' },
  { value: 'Future', label: 'Future', emoji: '📅', description: 'For later consideration' },
  { value: 'Past', label: 'Past', emoji: '✅', description: 'Completed or archived' }
]

// Helper function to get option by value
export const getOptionByValue = (options: ProjectOption[], value: string | number): ProjectOption | undefined => {
  return options.find(option => option.value === value)
}

// Helper function to get label by value
export const getLabelByValue = (options: ProjectOption[], value: string | number): string => {
  const option = getOptionByValue(options, value)
  return option?.label || 'Unknown'
}
